// extracted by mini-css-extract-plugin
export default {"heading":"heading-HTqW2","item":"item-JIpRZ"};